let navItemContainer = document.querySelectorAll(".nav-item_wrapper");

navItemContainer.forEach((item) => {
                            if(window.location.href === item.firstElementChild.href) {
                              let navImgConteiner = item.firstElementChild.children[0]
                              item.className += " nav-item_active";
                              navImgConteiner.className += " nav-img_wrapper_border"
                            }
                         })